import { useI18n } from "@/i18n";

export const TriggerChecklist = ({ brief, onChange, disabled, error }) => {
  const { t } = useI18n();
  const checklist = brief.triggerChecklist || [];
  if (brief.abstained || !checklist.length || !onChange) return null;
  return (
    <div className="mt-4" data-testid="trigger-checklist" aria-busy={disabled || undefined}>
      <ul className="m-0 list-none p-0">
        {checklist.map((entry, index) => (
          <li key={`${brief.id}-${index}`}>
            <label className="flex min-h-[48px] cursor-pointer items-start gap-3 py-3 text-base leading-6 text-ax-text">
              <input type="checkbox" checked={!!entry.checkedAt} disabled={disabled}
                onChange={(e) => onChange(index, e.target.checked)}
                data-testid={`trigger-checkbox-${index}`}
                className="mt-1 h-4 w-4 shrink-0 accent-ax-accent focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ax-focus-ring" />
              <span className="min-w-0 [overflow-wrap:anywhere]">{entry.text}</span>
            </label>
          </li>
        ))}
      </ul>
      {checklist.some((entry) => entry.checkedAt) && <p role="status" data-testid="trigger-occurred"
        className="m-0 mt-2 text-sm leading-5 text-ax-text-2">{t("trigger.occurred")}</p>}
      {error && <p role="alert" className="m-0 mt-2 text-sm leading-5 text-ax-error">{error}</p>}
    </div>
  );
};
